import cache from '../../shared/cache';
import connectionHndb from '../templates/connection.handlebars';
import { STORAGE_ACTIONS } from '..';

let tcc;

export const getConnectionDetails = async (service) => {
    if (tcc) return tcc;

    const {id: cartId} = await service.getCartDetails() ?? {id: null};

    if (!cartId) {
        cache.remove(STORAGE_ACTIONS.CONNECTION_DETAILS);
        tcc = null;
        return null;
    } else {
        tcc = cache.get(STORAGE_ACTIONS.CONNECTION_DETAILS);

        if (!tcc || tcc.cartId !== cartId) {
            const { data, status } = await service.getCartTcc(cartId);

            if (data) {
                tcc = data;
                cache.set(STORAGE_ACTIONS.CONNECTION_DETAILS, { ...tcc, cartId });
            }
        }
    }

    return tcc;
};

export const getConnectionElement = (connectionDetails) => {

    if (!connectionDetails) return null;

    const connectionEl = document.createElement('div');

    let detail = connectionDetails.online ? connectionDetails.details.online : connectionDetails.details.offline;
    let copyTccEl = null;    
    detail = detail.replace('{{tcc}}', 
        `
        <span style="cursor:copy; display:inline-block">
            <span id="copy-tcc">${connectionDetails.tcc}</span> 
            <i class="fa-regular fa-copy"></i>
        </span>
        `.trim()
    );

    connectionEl.innerHTML = connectionHndb({
        ...connectionDetails,
        detail: detail
    });

    if (copyTccEl = connectionEl.querySelector('#copy-tcc')) {
        copyTccEl.addEventListener('click', async(e) => {
            await navigator.clipboard.writeText(copyTccEl.textContent);
            console.log(copyTccEl.textContent);
        });
    }

    const linkElement = connectionEl.querySelector('a:not([href])');

    return {connectionElement: connectionEl.firstElementChild, linkElement};
};
